// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Almah Conta */
export const Almah = createBankIcon({
  name: "Almah Conta",
  slug: "almah",
  compe: null,
  color: "#1c1444",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#1c1444;fill-opacity:1\"\n     id=\"almah_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(22.8340,20.8193) scale(0.03898)\">\n    <path d=\"M 873.24339,446.37796 L 488.1962,885.71606 L 217.75853,648.45244 C 157.43781,596.17539 151.40583,504.69049 204.68916,444.37116 L 383.64105,240.2849 L 589.73714,5.032548 L 860.17416,242.29668 c 60.31927,52.27712 66.35471,143.76195 13.06923,204.08128 z\" style=\"fill:#ffffff\" />\n    <path d=\"M 1189.9311,1053.6197 L 804.88183,1492.9529 L 534.44385,1255.6942 c -60.32033,-52.2771 -66.35326,-143.767 -13.06977,-204.0862 L 700.32772,847.52168 L 906.42079,612.27484 L 1176.8569,849.53348 c 60.3242,52.27705 66.3547,143.76694 13.0742,204.08622 z\" style=\"fill:#ffffff\" />\n  </g>",
});
